// extracted by mini-css-extract-plugin
module.exports = {"desktopMq":"\"min-width: 62rem\"","bccContent":"utils_bccContent__Wq4xa","hrDividerLine":"utils_hrDividerLine__23IYD"};